import React from "react";
import styles from "./style.module.css";

import { Button } from "aible";

import { VIEW_TYPE } from "containers/View/reducer";

import AibleLogo from "images/Aible_Logo/Aible_Logo.png";
import pathFind from "images/tileIcons/walkthrough-dark.svg";
import Tour from "reactour";

export default class NewTour extends React.Component {
  // Hack so enter continues instead of closing tour
  hiddenUpdateStep(timeout) {
    const { step, updateStep } = this.props;

    document.getElementById("continueButton") &&
      document.getElementById("continueButton").children[0] &&
      document.getElementById("continueButton").children[0].click();

    return updateStep(step + 1);
  }

  render() {
    const { isOpen, step, updateIsOpen, updateStep, updateType } = this.props;

    const steps = [
      {
        selector: "#mainApp",
        content: ({ goTo, inDOM }) => (
          <div className={styles.tContent}>
            <div className={styles.aibleLogo}>
              <img src={AibleLogo} style={{ width: "100%", height: "auto" }} />
            </div>
            <div className={styles.tHeader + " " + styles.centered}>{"Welcome to Aible!"}</div>
            <div>
              {"Aible is an end-to-end solution that combines your human knowledge" +
                " and intuition with cutting edge AI to improve business decision making. "}
            </div>
            <div style={{ marginTop: "20px" }}>
              {"If you want to skip the walkthrough now you can always access the guide by clicking the " +
                "walkthrough button in the header"}
            </div>
            <div className={styles.logoWrapper}>
              <img
                src={pathFind}
                style={{
                  marginTop: "-2px",
                  width: "100%",
                  height: "auto"
                }}
              />
            </div>

            <div className={styles.tFooter}>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Begin Tour"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#menuTab_blueprints",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Blueprints Provide Best Practices and Guidance"}</div>
            <div>
              {"Blueprints will help you find the right data, ask you the right " +
                "questions to identify your cost-benefit tradeoffs and capacity " +
                "contraints. It will also help you evaluate your AI models " +
                "based on business impact for your unique use case."}
            </div>
            <div className={styles.tFooter}>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        action: (node) => {
          node.onclick = () => updateStep(step + 1);
        },
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#mainApp",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Blueprints for Your Use Case"}</div>
            <div>
              {
                "We have blueprints for many common use cases across industries and business functions with new blueprints added regularly."
              }
            </div>
            <div style={{ marginTop: "20px" }}>
              {
                "With Aible Advanced you can also create a blueprint in minutes that fits the unique needs of your company."
              }
            </div>
            <div className={styles.tFooter}>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#menuTab_datasets",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"All Your Data Accessible in One Place"}</div>
            <div>
              {"Any dataset you upload will be available in the datasets" +
                " tab and can be used in any project you create."}
            </div>
            <div className={styles.tFooter}>
              <Button
                type="primary"
                onClick={() => {
                  updateType(VIEW_TYPE.DATASETS);
                  return updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        action: (node) => {
          node.onclick = () => updateStep(step + 1);
        },
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#mainApp",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Evaluating AI Readiness"}</div>
            <div>
              {"Aible evaluates your data for 8 types of formatting issues and fixes any errors. " +
                "It also alerts you on the AI readiness of the data by evaluating each column " +
                "based on how likely it is to help predict the outcome you choose."}
            </div>
            <div className={styles.tFooter}>
              <Button type="primary" onClick={() => updateStep(step + 1)}>
                {"Next"}
              </Button>
            </div>
          </div>
        ),

        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#menuTab_deployments",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Deployed Projects"}</div>
            <div>
              {"The deployments tab shows any project with one or more models that have " +
                "been deployed or integrated into an external application. Any project that " +
                "has been integrated will show monitoring data that tracks the impact and " +
                "performance of the AI models."}
            </div>
            <div className={styles.tFooter}>
              <Button
                type="primary"
                onClick={() => {
                  updateType(VIEW_TYPE.DEPLOYMENTS);
                  return updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        action: (node) => {
          node.onclick = () => updateStep(step + 1);
        },
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#folderSelect",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Project Folders"}</div>
            <div>
              {"Folders organize all the assets created or accessible in Aible. " +
                "You can create and view all of the folders in your organization " +
                "that you have access rights to through this dropdown."}
            </div>
            <div style={{ marginTop: "20px" }}>
              {"These assets always reside in your own cloud account " +
                "and never in Aible servers. Only Aible Demos is a special " +
                "folder that contains training content and examples that " +
                "resides on Aible's cloud account and not yours."}
            </div>
            <div className={styles.tFooter}>
              <Button
                type="primary"
                onClick={() => {
                  updateType(VIEW_TYPE.EXPLORATIONS);
                  return updateStep(step + 1);
                }}
              >
                {"Next"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      },
      {
        selector: "#createProjectTile",
        content: () => (
          <div className={styles.tContent}>
            <div className={styles.tHeader}>{"Get Started"}</div>
            <div>
              {"A project contains the data, blueprint, and analysis that creates Aibles AI models. " +
                'Click the "Where should I start" button to begin.'}
            </div>
            <div className={styles.tFooter}>
              <Button type="primary" onClick={() => updateIsOpen(false)}>
                {"Get Started"}
              </Button>
            </div>
          </div>
        ),
        style: {
          maxWidth: "500px",
          minWidth: "500px"
        }
      }
    ];

    return (
      <Tour
        steps={steps}
        isOpen={Boolean(isOpen)}
        onRequestClose={() => updateIsOpen(false)}
        goToStep={step}
        startAt={step}
        showNavigation={false}
        showButtons={false}
        closeWithMask={false}
        disableInteraction={false}
        rounded={5}
        accentColor={"#512e77"}
      />
    );
  }
}
